<script>
    import { afterUpdate, createEventDispatcher, onMount } from "svelte";
    import { _ } from "../services/i18n"
    import ButtonGroup from "./ButtonGroup.svelte";
    import { search } from "../services/filters";

    const dispatch = createEventDispatcher();

    function itemClickedEvent() {
        dispatch('itemClicked', {
            selection: selectedItem
        });
    }

    function itemSelectedEvent() {
        dispatch('itemSelected', {
            selection: selectedItem
        });
    }

    function itemHoverEvent(evt,item) {
        const { clientX, clientY } = evt;
        dispatch('itemHover', {
            clientX, clientY,
            item
        });
    }

    function itemOutEvent() {
        dispatch('itemOut', {});
    }

    function cancelEvent() {
        selectedItem = null;
        dispatch('cancel', {});
    }

    export let list = [];
    export let columns = null;

    const visibleColumns = columns || list.length > 0 && Object.keys(list[0]) || [];

    let filteredItems = [];
    onMount(async () => {
        filterItems();
        searchField.focus();
    });

    afterUpdate(() => {
        filterItems();
    })

    let searchTerm = "";

    let selectedItem = null;

    let searchField;

    const filterItems = () => {
        const columns = list.length > 0 && Object.keys(list[0]) || [];
        filteredItems = search(searchTerm, list, columns);
    }

    const selectItem = (item) => {
        selectedItem = item;
        itemClickedEvent();
    }

    const hoverItem = (evt,item) => {
        itemHoverEvent(evt,item);
    }
</script>

<!-- Search box -->
<div class="search-field">
    <input 
        type="text" 
        placeholder={$_("ui_search_placeholder")} 
        bind:this={searchField}
        bind:value={searchTerm} 
        on:keyup={() => filterItems()}>
    <span>
        {filteredItems.length === 1 ? 
            $_("ui_other_one_element_found") : 
            filteredItems.length === 0 ? $_("ui_other_no_element_found") : `${filteredItems.length} ${$_("ui_other_elements_found")}`}
    </span>
</div>
<div class="list-items">
    <ul>
        {#each filteredItems as item}
            <li>
                <button 
                    on:mouseenter={(evt) => hoverItem(evt,item) }
                    on:mouseleave={() => itemOutEvent() }
                    on:click={() => selectItem(item) } 
                    class={selectedItem === item ? 'selected' : ''} 
                    on:dblclick={() => {
                        selectItem(item);
                        itemSelectedEvent();
                    }}>
                    {#each visibleColumns as name}
                        <div class="item-row">{item[name]}</div>
                    {/each}
                </button>
            </li>
        {/each}
    </ul>
</div>
<div class="actions">
    <ButtonGroup actions={{ 
        "ui_buttons_accept": itemSelectedEvent,
        "ui_buttons_cancel": cancelEvent
     }} disabled={{
        "ui_buttons_accept": !selectedItem
     }}></ButtonGroup>
</div>

<style>
    :root {
        --search-field-height: 46px;
        --actions-height: 46px;
    }

    .search-field {
        /*height: var(--search-field-height);*/
        width: 100%;
        padding-bottom: 5px;
        padding-top: 5px;

    }

    .search-field input { 
        border: 1px solid #36a9e1;
        border-radius: 5px;

    }

    .search-field input::placeholder { 
       color: #1b3258;

    }


    .list-items {
        overflow: auto;
        height: calc(95% - var(--search-field-height) - var(--actions-height));
        width: 100%;
        border: 1px solid #36a9e1;
        border-radius: 5px;

    }

    .actions {
        height: var(--actions-height);
        text-align: right;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    ul {
        padding: 0px;
    }

    li button {
        display: flex;
        background: none;
        border: none;
        width: 100%;
        padding-top: 2px;
        padding-bottom: 2px;
        margin: 0px;
    }

    li button:hover {
        background-color: #1b3258;
        color: white;
    }

    li button.selected {
        background-color: rgb(54 169 225);
    color: white;
    font-size: 1.2em;
    }

    div.item-row {
        flex: 1 1 0;
        letter-spacing: 1.1px;
       
    }
</style>